import React from 'react';
import { Button} from 'antd-mobile';
import defaultImg from './default.png'

class preserveValue extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
        };
    }

    render() {
        
        return (
            <div className="preserveValueBox">
                <img src={defaultImg} style={{width: '100%'}}/>
            </div>
        );
    }
}
export default preserveValue;


// WEBPACK FOOTER //
// ./src/preserveValue/index/index.js